// src/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();

    if (!window.localStorage.getItem("username")) {
        return <Navigate to="/login" />;
    }

    return children;
};

export default ProtectedRoute;
